import { IShowDialogParams } from "src/models";
import Dialoger from "src/components/Dialoger/Dialoger";

export default {
    dialogerComponent: null,

    dispose() {
        if (this.dialogerComponent) {
            this.dialogerComponent.dispose();
        }
        this.dialogerComponent = null;
    },

    show(params: IShowDialogParams) {
        if (!this.dialogerComponent) {
            this.dialogerComponent = new Dialoger({
                source: '<x-dialoger></x-dialoger>'
            });
            this.dialogerComponent.attach(document.body);
        }
        this.dialogerComponent.show(params)
    }
};
